<template>
  <TrfTopBar v-if="isLinkExterno && estilosAplicados" />
  <div v-show="(menuCarregado || isLinkExterno) && estilosAplicados" class="vue-app-container">
    <link
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css"
      rel="stylesheet"
    />
    <TrfWizardConfiguracaoPendente
      v-if="isModalConfiguracaoPendenteActive"
      :configuracaoPendente="configuracaoPendente"
      :isAberto="isModalConfiguracaoPendenteActive"
      :utilizarTransicao="false"
    />
    <router-view :statusTela=statusTela v-if="statusTela !== 'is-loading'" />
    <TrfFooter />
  </div>
</template>

<script>
import { acessoUtils } from "./util/acesso.utils";
import { cookieUtils } from "./util/cookie.utils";
import { jwtUtils } from "./util/jwt.utils";
import { routerUtils } from "./util/router.utils";
import { corUtils } from "./util/cor.utils";
import { poollingStore } from "./stateManagement/poolling";

import TrfFooter from "./components/Footer";
import TrfWizardConfiguracaoPendente from "./components/WizardConfiguracaoPendente";
import router from './router';
import { Authenticator } from './stateManagement/authenticator';
import { pessoaLogada } from './stateManagement/pessoaLogada';
import { defineAsyncComponent } from "vue";

let dragScrollInterval;

export default {
  components: {
    TrfTopBar: defineAsyncComponent(() => import('./components/TopBar/index.vue')),
    TrfFooter,
    TrfWizardConfiguracaoPendente
  },
  data() {
    return {
      operador: null,
      conexao: null,
      menuCarregado: false,
      isModalConfiguracaoPendenteActive: false, 
      statusTela: "",
      configuracaoPendente: {},
      isLinkExterno: false,
      estilosAplicados: false
    };
  },
  computed: {
    isFreemiumFaltandoInformacoesDoContador() {
      return acessoUtils.adquirirIsFreemiumFaltandoInformacoesDoContador(
        this.conexao
      );
    },
    pessoaLogada() {
      if (!!!this.operador) return;
      return acessoUtils.getPessoaLogada(this.operador, this.userConnection);
    },
    userConnection() {
      return acessoUtils.converterUserConnectionDominioParaMenu(this.conexao);
    }
  },
  methods: {
    _registrarComponenteNavbar() {
      const containerPadrao = document.querySelector(".vue-app-container");
      const navbarElement = document.createElement("wc-econt-navbar");
      navbarElement.style.position = "fixed";
      navbarElement.style.zIndex = "101";
      navbarElement.style.right = "0";
      navbarElement.pessoaLogada = this.pessoaLogada;
      navbarElement.userConnection = this.userConnection;
      navbarElement.addEventListener('dragenter', (ev) => {
        ev.preventDefault();
        const speed = 6;
        window.scrollBy(0, -speed);
        dragScrollInterval = setInterval(() => {
          window.scrollBy(0, -speed);
        }, 1)
      })
      navbarElement.addEventListener('dragleave', (ev) => {
        clearInterval(dragScrollInterval)
      })
      
      containerPadrao.prepend(navbarElement);
    },
    _registrarComponenteMenu() {
      const containerPadrao = document.querySelector(".vue-app-container");
      const menuElement = document.createElement("wc-econt-menu");
      menuElement.style.position = "fixed";
      menuElement.style.zIndex = "102";
      menuElement.pessoaLogada = this.pessoaLogada;
      menuElement.userConnection = this.userConnection;
      containerPadrao.prepend(menuElement);
    },
    async _adquirirOperador() {
      const operadorDados = await acessoUtils.adquirirOperadorLogado();
      this.operador = operadorDados;
    },
    async _adquirirConexao() {
      const userConnection = await acessoUtils.adquirirUserConnection();
      this.conexao = userConnection;
    },
    adquirirEstilosCookie() {
      if (!cookieUtils.verificarCookie("jwt")) return;
      const cookieJwt = cookieUtils.adquirirCookie("jwt");
      const cookieDecodificado = jwtUtils.DecodificarJWT(cookieJwt);

      const { logourl, corpri, corsec, corter } = cookieDecodificado;

      const Estilos = {
        LogoUrl: logourl,
        CorPrimaria: corpri,
        CorSecundaria: corsec,
        CorTercearia: corter,
      };
      return Estilos;
    },
    async adquirirEstilosIdentificacao(key) {
      if (!key) return;
      let estilo = await acessoUtils.getEstiloPersonsonalizado(key);
      
      const { logoMenuPath, corPrincipal, corSecundaria, corTerciaria } = estilo;

      const Estilos = {
        LogoUrl: logoMenuPath,
        CorPrimaria: corPrincipal,
        CorSecundaria: corSecundaria,
        CorTercearia: corTerciaria,
      };
      
      return Estilos;
    },
    isTemaPadrao(estilosDeCookie) {
      const isCorPrimariaPadrao = estilosDeCookie.CorPrimaria.toLowerCase() == "#a82339";
      const isCorSecundariaPadrao = estilosDeCookie.CorSecundaria.toLowerCase() == ("#ffffff" || "#fff");
      const isCorTerceariaPadrao = estilosDeCookie.CorTercearia.toLowerCase() == "#c22743";

      return isCorPrimariaPadrao && isCorSecundariaPadrao && isCorTerceariaPadrao;
    },
    gerarObjetoDeCores(estilosCookies) {
      if (!!!estilosCookies) return;

      const corPrimariaEmHSL = corUtils.converterHEXStringParaHSLObject(
        estilosCookies.CorPrimaria
      );
      const corPrimariaEmRGB = corUtils.converterHSLObjectParaRGBObject(
        corPrimariaEmHSL.h,
        corPrimariaEmHSL.s,
        corPrimariaEmHSL.l
      );
      const corSecundariaEmHSL = corUtils.converterHEXStringParaHSLObject(
        estilosCookies.CorSecundaria
      );
      const corSecundariaEmRGB = corUtils.converterHSLObjectParaRGBObject(
        corSecundariaEmHSL.h,
        corSecundariaEmHSL.s,
        corSecundariaEmHSL.l
      );
      const corTerciariaEmHSL = corUtils.converterHEXStringParaHSLObject(
        estilosCookies.CorTercearia
      );
      const brancoEmHSL = corUtils.converterHEXStringParaHSLObject("#FFF");
      const brancoEmRGB = corUtils.converterHSLObjectParaRGBObject(
        brancoEmHSL.h,
        brancoEmHSL.s,
        brancoEmHSL.l
      );

      const ObjetoDeCores = {
        logoUrl: estilosCookies.LogoUrl,
        primaryColor: estilosCookies.CorPrimaria,
        primaryColorLight: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          0,
          -1,
          +10
        ),
        primaryColorDark: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          0,
          -1,
          -3
        ),
        primaryColorDarker: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          0,
          -1,
          -5
        ),
        primaryColorDarkest: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          0,
          0,
          -10
        ),
        primaryColorLighter: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          0,
          0,
          +20
        ),
        primaryColorDesaturated: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          -10,
          +9,
          -10
        ),
        primaryColorSaturated: corUtils.gerarHSLString(
          corPrimariaEmHSL.h,
          corPrimariaEmHSL.s,
          corPrimariaEmHSL.l,
          -350,
          +4,
          +5
        ),
        primaryColorShadow: corUtils.gerarRGBAString(
          corPrimariaEmRGB.r,
          corPrimariaEmRGB.g,
          corPrimariaEmRGB.b,
          0.25
        ),
        white: "#FFF",
        whiteDark: corUtils.gerarHSLString(
          brancoEmHSL.h,
          brancoEmHSL.s,
          brancoEmHSL.l,
          0,
          0,
          -2
        ),
        whiteDarker: corUtils.gerarHSLString(
          brancoEmHSL.h,
          brancoEmHSL.s,
          brancoEmHSL.l,
          0,
          0,
          -8
        ),
        whiteOp90: corUtils.gerarRGBAString(
          brancoEmRGB.r,
          brancoEmRGB.g,
          brancoEmRGB.b,
          0.9
        ),
        whiteOp70: corUtils.gerarRGBAString(
          brancoEmRGB.r,
          brancoEmRGB.g,
          brancoEmRGB.b,
          0.7
        ),
        secondaryColor: estilosCookies.CorSecundaria || brancoEmRGB,
        secondaryColorDark: corUtils.gerarHSLString(
          corSecundariaEmHSL.h,
          corSecundariaEmHSL.s,
          corSecundariaEmHSL.l,
          0,
          0,
          -2
        ),
        secondaryColorDarker: corUtils.gerarHSLString(
          corSecundariaEmHSL.h,
          corSecundariaEmHSL.s,
          corSecundariaEmHSL.l,
          0,
          0,
          -2
        ),
        secondaryColor90: corUtils.gerarRGBAString(
          corSecundariaEmRGB.r,
          corSecundariaEmRGB.g,
          corSecundariaEmRGB.b,
          0.9
        ),
        secondaryColor70: corUtils.gerarRGBAString(
          corSecundariaEmRGB.r,
          corSecundariaEmRGB.g,
          corSecundariaEmRGB.b,
          0.7
        ),
        tertiaryColor: estilosCookies.CorTercearia,
      };

      return ObjetoDeCores;
    },
    gerarStyleDeVariaveis(objetoDeCores) {
      let estilos = `:root {\n`;
      Object.entries(objetoDeCores).forEach((cor) => {
        const [key, value] = cor;
        estilos += `--${key}: ${value};\n`;
      });
      estilos += "}";

      return estilos;
    },
    adicionarStylesNoDocumento(styleString, id) {
      const elemento =
        document.getElementById(id) || document.createElement("style");
      if (!!elemento.id == id) {
        elemento.textContent = styleString;
      } else {
        elemento.id = id;
        elemento.textContent = styleString;
        document.querySelector("body").appendChild(elemento);
      }
    },
    adicionarEstilosPadraoAoTema(objetoDeTema) {  
      objetoDeTema = {
        ...objetoDeTema,
        tabDefaultColor: "#555"
      }

      return objetoDeTema;
    },
    async aplicarTemaNoProjeto(isRotaAnonima, key) {
      let cores = isRotaAnonima ? 
        await this.adquirirEstilosIdentificacao(key) : 
        this.adquirirEstilosCookie();

      let objetoDeTema = this.gerarObjetoDeCores(cores);
      if(this.isTemaPadrao(cores)) {
        objetoDeTema = this.adicionarEstilosPadraoAoTema(objetoDeTema);
      }
      const styleString = this.gerarStyleDeVariaveis(objetoDeTema);
      this.adicionarStylesNoDocumento(styleString, "tfs-tema-vars");

      this.estilosAplicados = true;
    },
  },
  async mounted() {
    router.isReady().then(async () => {
      if (router.currentRoute.value.meta.openRoute) {
        this.isLinkExterno = true;
      } else {
        this.isLinkExterno = false;
      }

      if (!router.currentRoute.value.meta.openRoute && await Authenticator.getIsAuthenticated) {
        await pessoaLogada.atualizar();        
        await this._adquirirOperador();
        await this._adquirirConexao();
        this._registrarComponenteMenu();
        this._registrarComponenteNavbar();
        this.menuCarregado = true;
        this.aplicarTemaNoProjeto();
        poollingStore.StartPoolling();
      }

      if(router.currentRoute.value.meta.openRoute) {
        let objetoKey = router.currentRoute.value.query;
        try {
          await this.aplicarTemaNoProjeto(true, objetoKey.key);
        } catch {
          await this.aplicarTemaNoProjeto(false);
        }
      }

      routerUtils.iniciarEventoDeRouter();
    })
  },
  created() {
    document.addEventListener('trf-show-modal-configuracao-pendente', (e) =>  {
      const detail = e.detail;
      this.statusTela = detail.statusTela;
      this.configuracaoPendente = detail.configuracaoPendente;
      this.isModalConfiguracaoPendenteActive = detail.isModalConfiguracaoPendenteActive
    });
  },
  unmounted() {
    routerUtils.removerEventoDeRouter();
  },
};
</script>
<style lang="scss" scoped>
.vue-app-container {
  padding: 5.25rem 1rem 0 4.24rem;
}
@media screen and (max-width: 768px) {
  .vue-app-container {
    padding: 5.25rem 1rem 0 1rem;
    .wc-econt-navbar {
      right: 0;
    }
  } 
}
</style>
<style lang="scss">
.vue-app-container > .container {
  width:100% !important;
  max-width:1152px !important;
}
@media screen and (max-width: 768px) {
  wc-econt-nav {
    right: 0!important;
  }
  .vue-app-container > .container {
    max-width: none!important;
  }
}
</style>
